module.exports = __webpack_public_path__ + "static/media/Reddit.e22e2fd7.png";